<template>
  <div class="detail-more" v-if="graduates.data.length">
    <h2 class="detail-more-title" v-if="profession">
      {{ $t('detail.more') }} {{ profession[$t('key')] }}
    </h2>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-for="graduate in graduates.data"
        :key="graduate.id"
      >
        <graduate-card :graduate="graduate"></graduate-card>
      </v-col>
    </v-row>
    <div class="graduates-more">
      <button
        class="graduates-more-button"
        v-if="graduates.showMore"
        @click="showMore"
      >
        {{ $t('home.load_more') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import GraduateCard from '@/components/GraduateCard'

export default {
  props: {
    graduate: Object
  },
  data() {
    return {
      profession: {}
    }
  },
  computed: {
    graduates() {
      return this.$store.getters['graduates/getByProfession'](
        this.graduate.profession_global_id,
        this.graduate.id
      )
    }
  },
  mounted() {
    this.$store.dispatch('graduates/resetDetailLimit')

    axios
      .get(process.env.VUE_APP_API + `/professions-global?_format=json`)
      .then(professions => {
        this.profession = professions.data.find(
          profession => profession.id === this.graduate.profession_global_id
        )
      })
  },
  methods: {
    showMore() {
      this.$store.dispatch('graduates/increaseDetailLimit')
    }
  },
  components: {
    GraduateCard
  }
}
</script>

<style lang="scss">
.detail-more {
  margin-top: 150px;
}

.detail-more-title {
  margin-bottom: 40px;
}
</style>
